import ForumIcon from "@mui/icons-material/Forum";
import { Grid } from "@mui/material";
import { useUserInfo } from "@sans-service-tier/sdk-react";

import { useAppState } from "../../hooks/useAppState";
import { HelpAndSupportHeader } from "./HelpAndSupportHeader";
import { Title, ZopimContainer } from "./ZopimChat.elements";

export const stripCommas = (str: string) => {
  return str.replace(/,/g, "");
};

export function ZopimChat() {
  const userInfo = useUserInfo();
  const { course, module, slide } = useAppState();

  const zopimTags = {
    firstName: userInfo.given_name,
    lastName: userInfo.family_name,
    email: userInfo.email,
    shortName: course?.shortName,
    version: course?.fullVersion,
    loOrder: module?.fullNumber,
    slideTitle: stripCommas(slide?.name || ""),
    slideIndex: slide?.number,
  };

  localStorage.setItem("zopimTags", JSON.stringify(zopimTags));

  if (!userInfo) return null;

  return (
    <>
      <Grid container flexDirection="row">
        <HelpAndSupportHeader>
          <Grid
            container
            size={{ xs: 6 }}
            gap={1}
            sx={{ flexGrow: 1 }}
            alignItems="center"
            aria-live="assertive"
            className="header-wrapper"
          >
            <ForumIcon sx={{ color: theme => theme.custom.palette.white, width: 20, height: 20 }} />
            <Title className="tech-support-header">Chat with SME</Title>
          </Grid>
        </HelpAndSupportHeader>
      </Grid>
      <ZopimContainer container flexDirection="row">
        <div id="zopim-widget"></div>
      </ZopimContainer>
    </>
  );
}
